import NotFooterLayout from "layouts/NotFooterLayout";
import CreateProduct from "components/ManageProduct/CreateProduct";

function CreateProductPage() {
  return (
    <>
      <NotFooterLayout namePage="เพิ่มสินค้า"  >
        <div className="layout-content">
          <CreateProduct />
        </div>
      </NotFooterLayout>
    </>
  );
}

export default CreateProductPage;
